import React from "react";
import ReactDOM from "react-dom/client";
import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  ApolloProvider,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import Publications from "./pages/publications/Main";
import Marketing from "./pages/marketing/Main";
import About from "./pages/marketing/About";
import Publishing from "./pages/marketing/Publishing";
import Submissions from "./pages/marketing/Submissions";
import Features from "./pages/marketing/Features";
import Guidelines from "./pages/marketing/Guidelines";
import UserDashboard from "./pages/dashboard/Main";
import ViewPublication from "./pages/publications/ViewPublication";
import AdminDashboard from "./pages/admin_dashboard/Main";
import Community from "./pages/community/Main";
import UserProfile from "./pages/user_profile/Main";
import Collection from "./pages/collection/Main";
import SchoolClass from "./pages/school_class/Main";
import GradedAssignment from "./pages/graded_assignment/Main";
import InputAssignment from "./pages/input_assignment/Main";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import TermsOfService from "./pages/legal/TermsOfService";
import Layout from "./components/Layout";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// const client = new ApolloClient({
//   uri: process.env.REACT_APP_INKBOWL_API_HOST,
//   cache: new InMemoryCache(),
// });

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_INKBOWL_API_HOST}/graphql`,
});

const token = process.env.REACT_APP_INKBOWL_API_TOKEN;
const authLink = setContext((_, { headers }) => {
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN!}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: "openid profile email",
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <ApolloProvider client={client}>
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <Layout>
                  <Marketing />
                </Layout>
              }
            />
            <Route
              path="/about"
              element={
                <Layout>
                  <About />
                </Layout>
              }
            />
            <Route
              path="/publishing"
              element={
                <Layout>
                  <Publishing />
                </Layout>
              }
            />
            <Route
              path="/submissions"
              element={
                <Layout>
                  <Submissions />
                </Layout>
              }
            />
            <Route
              path="/features"
              element={
                <Layout>
                  <Features />
                </Layout>
              }
            />
            <Route
              path="/guidelines"
              element={
                <Layout>
                  <Guidelines />
                </Layout>
              }
            />
            <Route
              path="/users/:handle"
              element={
                <Layout>
                  <UserProfile />
                </Layout>
              }
            />
            <Route
              path="/publications"
              element={
                <Layout>
                  <Publications />
                </Layout>
              }
            />
            <Route
              path="/publications/:uuid"
              element={
                <Layout>
                  <ViewPublication />
                </Layout>
              }
            />
            <Route path="/dashboard" element={<UserDashboard />} />
            <Route
              path="/community"
              element={
                <Layout>
                  <Community />
                </Layout>
              }
            />
            <Route
              path="/admin"
              element={
                <Layout>
                  <AdminDashboard />
                </Layout>
              }
            />
            <Route
              path="/classes/:uuid"
              element={
                <Layout>
                  <SchoolClass />
                </Layout>
              }
            />
            <Route
              path="/graded_assignments/:uuid"
              element={
                <Layout>
                  <GradedAssignment />
                </Layout>
              }
            />
            <Route
              path="/input_assignments/:uuid"
              element={
                <Layout>
                  <InputAssignment />
                </Layout>
              }
            />
            <Route
              path="/collections/:uuid"
              element={
                <Layout>
                  <Collection />
                </Layout>
              }
            />
            <Route
              path="/privacy-policy"
              element={
                <Layout>
                  <PrivacyPolicy />
                </Layout>
              }
            />
            <Route
              path="/terms-of-service"
              element={
                <Layout>
                  <TermsOfService />
                </Layout>
              }
            />
          </Routes>
        </Router>
      </ApolloProvider>
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
